import { QuizItemCache } from '../../../../api/quiz/getQuizzes/normalize/toQuizItemCache';

export const getFreeQuizzesFilter = () => (cache: QuizItemCache) =>
  cache.itemIdByType.quiz
    .map((itemId) => cache.itemById[itemId])
    .filter((quizOrFolder) => quizOrFolder.deleted === false);
